// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-InfiniteCarousel-module__infiniteCarouselContainer-xj9Ca {
  overflow: hidden;
  width: 100%;
  mask: linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%);
  -webkit-mask: linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%);
}

.nightbot-InfiniteCarousel-module__carouselTrack-T4X25 {
  display: flex;
  white-space: nowrap;
  flex-shrink: 0;
}

.nightbot-InfiniteCarousel-module__infiniteCarousel-IvbIF {
  display: flex;
}

.nightbot-InfiniteCarousel-module__infiniteCarousel-IvbIF > * {
    flex: 0 0 auto;
    min-width: 200px;
  }
`, "",{"version":3,"sources":["webpack://./src/components/landing/InfiniteCarousel.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,uFAAuF;EACvF,+FAA+F;AACjG;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AAMf;;AAJE;IACE,cAAc;IACd,gBAAgB;EAClB","sourcesContent":[".infiniteCarouselContainer {\n  overflow: hidden;\n  width: 100%;\n  mask: linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%);\n  -webkit-mask: linear-gradient(to right, transparent 0%, black 30%, black 70%, transparent 100%);\n}\n\n.carouselTrack {\n  display: flex;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.infiniteCarousel {\n  display: flex;\n\n  & > * {\n    flex: 0 0 auto;\n    min-width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infiniteCarouselContainer": `nightbot-InfiniteCarousel-module__infiniteCarouselContainer-xj9Ca`,
	"carouselTrack": `nightbot-InfiniteCarousel-module__carouselTrack-T4X25`,
	"infiniteCarousel": `nightbot-InfiniteCarousel-module__infiniteCarousel-IvbIF`
};
export default ___CSS_LOADER_EXPORT___;
